export class SimpleCache<T> {
  #cache = new Map<string, T>();

  getOrCreate(key: string, createItem: () => T): T {
    if (!this.#cache.has(key)) {
      this.#cache.set(key, createItem());
    }

    return this.#cache.get(key)!;
  }
}
